export default __webpack_public_path__ + "static/media/icon_google.0a5f67e1.svg";